// extracted by mini-css-extract-plugin
module.exports = {"bold":"RichTextWithIconRichText_bold__kHx3n","title":"RichTextWithIconRichText_title__0rL3x"};